import { useSnapshot } from 'valtio'
import notificationCenterStore from '../store/notificationCenterStore'

type OptimizationLogVisibility = {
  showNewOptimizationLogs: boolean
}
//TO BE REMOVED WHEN NEW OPTIMIZATION LOG IS FULLY RELEASED

export function useOptimizationLogVisibility(): OptimizationLogVisibility {
  const { useNewOptimizationLog } = useSnapshot(notificationCenterStore)

  return {
    showNewOptimizationLogs: useNewOptimizationLog,
  }
}
